import { useRouter } from 'next/router';
import { getFormattedDate } from '../../DueDate/CalculatorBox/utils';
import { DueDate, Recalculate } from './styled';
import { images } from '../../../Constants/ImageUrls';

function DueDateResultPage(props) {
  const { dueDate, setDueDate } = props;
  const date = getFormattedDate(dueDate);
  const router = useRouter();

  return (
    <DueDate>
      <h5>Your Due Date is: </h5>
      <p>{date}</p>
      <Recalculate
        Recalculate
        onClick={() => {
          setDueDate(null);
          router.back();
        }}
      >
        <img src={images.refreshIcon} alt="" width="20px" height="20px" />
        &nbsp;Recalculate your due date
      </Recalculate>
    </DueDate>
  );
}

export default DueDateResultPage;
